import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Signup = styled.div`
  width: 660px;
  max-width: 100%;
  background: var(--white);
  border-radius: 12px;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const Form = styled.form`
  padding: 28px 35px 28px;

  @media (max-width: 767px) {
    padding: 24px 20px;
  }
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: center;
  padding: 21px 35px;
  background: var(--aluminium10);
  border-radius: 0 0 12px 12px;
  border-top: 1px solid var(--aluminium35);

  @media (max-width: 767px) {
    padding: 16px 20px;
  }
`;

export const LoginLink = styled.div`
  color: var(--blue100);
  cursor: pointer;
  padding-left: 5px;

  &:hover {
    color: var(--blue120);
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 1.4em;
  color: var(--carbone100);
  margin-bottom: 1.3em;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-left: -6px;
  margin-right: -6px;

  &:last-child {
    margin-bottom: 0;
  }

  .input {
    flex-grow: 1;
  }
`;

export const Column = styled.div`
  flex-grow: 1;
  padding-left: 6px;
  padding-right: 6px;
`;

export const Button = styled.button`
  width: 149px;
`;

export const BText = styled.div`
  display: flex;
  font-size: 14px;
  color: var(--carbone80);
`;

export const Rules = styled(Link)`
  padding: 0 5px;
`;
